import { render, staticRenderFns } from "./OrderDetailBonusTable.vue?vue&type=template&id=79be21a8&"
import script from "./OrderDetailBonusTable.vue?vue&type=script&lang=js&"
export * from "./OrderDetailBonusTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports